import {Component, OnInit} from '@angular/core';
import {LoadingPage} from '../../../../shared/components/loading/loading.page.component';
import {Subject, Subscription} from 'rxjs';
import {LicenseService} from '../../../services/license.service';
import {NotificationService} from '../../../services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'itpx-evaluation-deliverables',
  templateUrl: './deliverables.component.html',
  styleUrls: ['./deliverables.component.css']
})
export class EvaluationDeliverablesComponent extends LoadingPage implements OnInit {

  private sub: Subscription;
  private deliverables: Array<any>;
  private errorMessage: String;
  private errorTitle: String;
  private update = new Subject<any>();
  profile: any;


  constructor(private licenseService: LicenseService,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    this.update.subscribe(assignmentId => {
      this.licenseService.getEvaluationDeliverables(assignmentId)
        .subscribe(deliverables => {
          this.loadAssignments(deliverables, assignmentId);
        }, e => {
          this.errorMessage = e.json().error.message;
          this.errorTitle = 'We’re Sorry...';
          this.error();
        });
    });

    this.sub = this.route.params.subscribe(params => {
      let assignmentId = params['assignmentId'];
      this.update.next(assignmentId);
    });
  }

  private loadAssignments(deliverables: any, assignmentId: any) {
    if (deliverables['data'] && Array.isArray(deliverables.data) && deliverables.data.length > 0) {
      this.deliverables = deliverables['data'].map(d => {
        d.assignmentId = assignmentId;
        d.disabled = !d.enabled;
        return d;
      });
      this.ready();
    } else {
      this.errorMessage = null;
      this.error();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/deliverable/deliverables.component.ts